export const tableStyles = `
  .edit-btn, .delete-btn {
    padding: 4px 8px;
    margin: 2px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
  }
  .edit-btn {
    background-color: #3182ce;
    color: white;
  }
  .edit-btn:hover {
    background-color: #2c5aa0;
  }
  .delete-btn {
    background-color: #e53e3e;
    color: white;
  }
  .delete-btn:hover {
    background-color: #c53030;
  }
  .handsontable {
    font-size: 14px;
  }
  .handsontable td {
    vertical-align: middle;
  }
  .handsontable .htCore td {
    padding: 8px;
  }
  /* Hide RJSF submit button in modal */
  .rjsf .btn-submit {
    display: none !important;
  }
  .rjsf button[type="submit"] {
    display: none !important;
  }
`;

